<div class="h-screen overflow-hidden bg-white flex">
  <app-sidebar
    [isMobileOpen]="isSidebarOpen()"
    [isCollapsed]="isSidebarCollapsed()"
    (mobileOpenChange)="setSidebarOpen($event)"
    (collapsedChange)="setSidebarCollapsed($event)"></app-sidebar>

  <div class="flex min-w-0 min-h-0 flex-1 flex-col overflow-hidden">
    <app-header (menuClick)="toggleSidebar()"></app-header>

    <main class="min-h-0 flex-1 overflow-y-auto p-5">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
